import { Routes } from '@angular/router';
import { authGuard } from './guards/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    title: 'ISTID - Logowanie',
    loadComponent: () => import('./common/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'reset-password',
    title: 'ISTID - Reset hasła',
    loadComponent: () => import('./common/reset-password/reset-password.component').then(c => c.ResetPasswordComponent)
  },
  {
    path: '403',
    title: 'ISTID - Brak dostępu',
    loadComponent: () => import('./common/errors/error403/error403.component').then(m => m.Error403Component)
  },
  {
    path: '404',
    title: 'ISTID - Nie znaleziono strony',
    loadComponent: () => import('./common/errors/error404/error404.component').then(m => m.Error404Component)
  },
  {
    path: 'admin',
    title: 'ISTID - Admin - Dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./admin/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    children: [
      {
        path: 'products',
        title: 'ISTID - Admin - Produkty',
        data: { breadcrumb: 'Produkty' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./admin/products/products.component').then(m => m.ProductsComponent),
          },
          {
            path: 'releaseProduct',
            title: 'ISTID - Admin - Formularz wydania produktu',
            data: { breadcrumb: 'Formularz wydania produktu' },
            loadComponent: () => import('./admin/products/product-release/product-release.component').then(m => m.ProductReleaseComponent)
          },
          {
            path: 'releaseProduct/:id',
            title: 'ISTID - Admin - Formularz edycji produktu',
            data: { breadcrumb: 'Formularz wydania produktu' },
            loadComponent: () => import('./admin/products/product-release/product-release.component').then(m => m.ProductReleaseComponent)
          },
          {
            path: 'productDetail',
            title: 'ISTID - Admin - Produkt',
            data: { breadcrumb: 'Produkt' },
            loadComponent: () => import('./admin/products/product-detail/product-detail.component').then(m => m.ProductDetailComponent)
          },
          {
            path: 'importProducts',
            title: 'ISTID - Admin - Import produktów',
            data: { breadcrumb: 'Import produktów' },
            loadComponent: () => import('./admin/products/importer/importer.component').then(m => m.ImporterComponent)
          }
        ]
      },
      {
        path: 'artists',
        title: 'ISTID - Admin - Artyści',
        data: { breadcrumb: 'Artyści' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./admin/artists/artists.component').then(m => m.ArtistsComponent)
          },
          {
            path: 'artistDetail',
            title: 'ISTID - Admin - Artysta',
            data: { breadcrumb: 'Artysta' },
            loadComponent: () => import('./admin/artists/artist-detail/artist-detail.component').then(m => m.ArtistDetailComponent)
          },
        ],
      },
      {
        path: 'tickets',
        title: 'ISTID - Admin - Narzędzia',
        data: { breadcrumb: 'Zadania' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./admin/tickets/tickets.component').then(m => m.TicketsComponent)
          },
          {
            path: 'ticketDetail',
            title: 'ISTID - Admin - Zadanie',
            data: { breadcrumb: 'Zadanie' },
            loadComponent: () => import('./admin/tickets/ticket-detail/ticket-detail.component').then(m => m.TicketDetailComponent)
          }
        ]
      },
      {
        path: 'contractors',
        title: 'ISTID - Admin - Kontrahenci',
        data: { breadcrumb: 'Kontrahenci' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./admin/contractors/contractors.component').then(m => m.ContractorsComponent),
          },
          {
            path: 'contractorDetail',
            title: 'ISTID - Admin - Kontrahent',
            data: { breadcrumb: 'Kontrahent' },
            loadComponent: () => import('./admin/contractors/contractor-detail/contractor-detail.component').then(m => m.ContractorDetailComponent)
          },
        ],
      },
      {
        path: 'journalists',
        title: 'ISTID - Admin - Dziennikarze',
        data: { breadcrumb: 'Dziennikarze' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./admin/journalists/journalists.component').then(c => c.JournalistsComponent),
          },
          {
            path: 'journalistDetails',
            title: 'ISTID - Admin - Dziennikarz',
            data: { breadcrumb: 'Dziennikarz' },
            loadComponent: () => import('./admin/journalists/journalist-details/journalist-details.component').then(c => c.JournalistDetailsComponent)
          },
        ],
      },
      {
        path: 'settings/users',
        title: 'ISTID - Użytkownicy',
        data: { breadcrumb: 'Użytkownicy' },
        loadComponent: () => import('./settings/users/users.component').then(m => m.UsersComponent)
      }
    ]
  },
  {
    path: 'pressRoom',
    title: 'ISTID - PressRoom',
    canActivate: [authGuard],
    loadComponent: () => import('./pressRoom/pressroom-layout/pressroom-layout.component').then(c => c.PressroomLayoutComponent),
    children: [
      {
        path: 'home',
        title: 'ISTID - PressRoom - Dashboard',
        data: { breadcrumb: 'Dashboard' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./pressRoom/pressroom-home/pressroom-home.component').then(c => c.PressroomHomeComponent),
          },
        ]
      },
      {
        path: 'artists',
        title: 'ISTID - PressRoom - Artyści',
        data: { breadcrumb: 'Artyści' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./pressRoom/artists/artists.component').then(c => c.ArtistsComponent),
          },
          {
            path: 'artistProfile',
            title: 'ISTID - PressRoom - Profil artysty',
            data: {
              breadcrumb: 'Profil artysty'
            },
            loadComponent: () => import('./pressRoom/artists/artist-profile/artist-profile.component').then(c => c.ArtistProfileComponent),
          },
        ]
      },
      {
        path: 'albums',
        title: 'ISTID - PressRoom - Albumy',
        data: { breadcrumb: 'Albumy' },
        children: [
          {
            path: '',
            data: {
              breadcrumb: null
            },
            loadComponent: () => import('./pressRoom/albums/albums.component').then(c => c.AlbumsComponent),
          },
          {
            path: 'albumDetails',
            title: 'ISTID - PressRoom - Album',
            data: {
              breadcrumb: 'Album'
            },
            loadComponent: () => import('./pressRoom/albums/album-details/album-details.component').then(c => c.AlbumDetailsComponent),
          },
        ]
      }
    ]
  }
];
